import * as React from "react";
import { withStyles } from "@material-ui/core";
import { Classes, createStyles } from "@theme";
import Icon from "@material-ui/icons/FileCopy";
import CheckIcon from "@material-ui/icons/Check";
import locale from "@bonliva-crm/locale";
import clipboard from "@utils/clipboard";

type Props = {
  classes: Classes<typeof styles>;
  value: string;
  className: string;
};
type State = {
  clicked?: boolean;
};
class CopyIcon extends React.Component<Props, State> {
  r: HTMLDivElement;
  state: State = {};
  render() {
    const { value, className } = this.props;
    if (!value) {
      return null;
    }
    const { clicked } = this.state;
    const Component = clicked ? CheckIcon : Icon;

    return (
      <div
        title={locale.CopyValue(value)}
        ref={(r) => (this.r = r)}
        className={className}
      >
        <Component
          fontSize="inherit"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.setState({ clicked: true });

            clipboard(value, this.r);
            setTimeout(() => this.setState({ clicked: false }), 1000);
          }}
        />
      </div>
    );
  }
}
const styles = createStyles((t) => ({
  root: {
    zIndex: 10
  }
}));

export default withStyles(styles)(CopyIcon);
